import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import es from "./locales/es.json";
import pt from "./locales/pt.json";
import en from "./locales/en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      pt: { translation: pt },
      en: { translation: en },
    },
    lng: typeof window !== "undefined" ? (localStorage.getItem("kiltro_lang") || "es") : "es",
    fallbackLng: "es",
    supportedLngs: ["es", "pt", "en"],
    interpolation: { escapeValue: false },
    detection: {
      // Prioriza la elección explícita del usuario en localStorage,
      // y si no hay nada, fuerza Español por defecto (no detecta navegador).
      order: ["localStorage"],
      caches: ["localStorage"],
      lookupLocalStorage: "kiltro_lang",
    },
  });

export default i18n;
